import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'app-pie-graph',
    templateUrl: './pie-graph.component.html',
    styleUrls: ['./pie-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PieGraphComponent implements OnInit {
	@Input() list: any;
	@Input() total: number;
	@Input() dataType: string;
	@Input() valueType: string;
	@Input() multiple: boolean = false;
	@Input() tittle: string;
	@Input() selectedIndex: number = 1;
	@Input() border: boolean = false;
	selectedValue: any = [];

	getlineSpace(ev, index?) {
		if (this.multiple && index >= 1) {
			let pendingValue = 0;
			for (let i = 0; i < this.list.length; i++) {
				if (i > index) {
					pendingValue += this.list[i].value
				}
			}
			return ((ev + pendingValue) / this.total * 754) + ', 754'
		} else {
			return (ev / this.total * 754) + ', 754'
		}
	}
	getTimeValue(value) {
		var min = Math.floor(parseFloat(value) / 60)
		var sec = parseFloat(value) - min * 60
		return '' + min

		// if (sec < 10) {
		// 	return '' + min + ':0' + sec
		// } else {
		// 	return '' + min + ':' + sec
		// }
	}
	checkRotation(ev) {
		if (this.dataType == 'Percent') {
			var pos = 0
			var a = -90
			for (let line of this.list) {
				if (pos < ev) {
					var rot = line.value / this.total * (-360);
					a -= rot;
					//a += line.value / this.total * 360 * -1
				}
				pos++
			}
			var p = 'rotate(' + a + ' 150 150)'
			return p
		} else if (this.dataType == 'PercentSpecial') {
			var a = -90
			if (ev == 0) {
				var rot = this.list[1].value / this.total * (-360);
				a -= rot;
			}
			var p = 'rotate(' + a + ' 150 150)'
			return p
		} else {
			return 'rotate(-90 150 150)'
		}
	}
	showItem(pos) {
		this.selectedValue = this.list[pos]
	}
	startGraph() {
		this.selectedValue = this.list[this.selectedIndex]
	}

	constructor() { }

	ngOnInit() {
		this.selectedValue = this.list[this.selectedIndex]
	}

}
